"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenContainer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const TokenContainer = (0, _styled.default)("span")`
    background-color: ${_ref => {
  let {
    backgroundColor
  } = _ref;
  return backgroundColor;
}};
    color: ${_ref2 => {
  let {
    textColor
  } = _ref2;
  return textColor;
}};
    border-radius: 2px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 4px;

    // Elide if the token is wider than its container.
    overflow: hidden;
`;
exports.TokenContainer = TokenContainer;
//# sourceMappingURL=TokenContainer.js.map